import Vue from 'vue';
import Router, { Route } from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/project/tenant',
    },
    {
      path: '/project/tenant',
      components: {
        default: () => import('./views/Tenant.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({tenantId:route.query.tenantId}), sidebar: false }            
    },
    {
      path: '/project/subscription',
      components: {
        default: () => import('./views/Subscription.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({tenantId:route.query.tenantId}), sidebar: false }         
    },

    {
      path: '/project/billing',
      components: {
        default: () => import('./views/Billing.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({tenantId:route.query.tenantId, closingDate:route.query.closingDate}), sidebar: false }      
    },
    {
      path: '/project/billingItem',
      components: {
        default: () => import('./views/BillingItem.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({tenantId:route.query.tenantId, closingDate:route.query.closingDate}), sidebar: false }
    },
    {
      path: '/project/paymentItem',
      components: {
        default: () => import('./views/PaymentItem.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({tenantId:route.query.tenantId, closingDate:route.query.closingDate}), sidebar: false }
    },    
    {
      path: '/project/billingItem/:tenantId',
      components: {
        default: () => import('./views/BillingItem.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: true, sidebar: false }
    },
    {
      path: '/project/partner',
      components: {
        default: () => import('./views/PartnerPayment.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({tenantId:route.query.tenantId, dueDate:route.query.dueDate}), sidebar: false }      
    },    
    {
      path: '/operation/Topics',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('@/agiles/vues/topics.vue'),
      },
      props: { default: (route : Route) =>({isAdmin:true,isEditMode:true}), sidebar: false }          
    },    
    {
      path: '/operation/HelpContent',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('./views/HelpContent.vue'),
      },
    },        
    {
      path: '/operation/ProductTour',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('./views/ProductTour.vue'),
      },
      props: { default: (route : Route) =>({isAdmin:true,isEditMode:true}), sidebar: false }          
    },        
    {
      path: '/operation/campaign',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('./views/Campaign.vue'),
      },
      props: { default: (route : Route) =>({id:route.query.id}), sidebar: false }          
    },        
    {
      path: '/operation/campaignEntry',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('./views/CampaignEntry.vue'),
      },
      props: { default: (route : Route) =>({campaignId:route.query.campaignId}), sidebar: false }          
    },       
    {
      path: '/operation/SystemLog',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('@/agiles/vues/systemLog.vue'),
      },
      props: { default: (route : Route) =>({id:route.query.id}), sidebar: false }                   
    },
    {
      path: '/operation/Coupon',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('./views/Coupon.vue'),
      },
      props: { default: (route : Route) =>({id:route.query.id}), sidebar: false }                   
    },
    //以下はシステムメニュー
    {
      path: '/plan/pricing',
      components: {
        default: () => import('./views/Pricing.vue'),
        sidebar: () => import('./sidebars/plan.vue'),
      },
    },
    {
      path: '/plan/option',
      components: {
        default: () => import('./views/OptionPricing.vue'),
        sidebar: () => import('./sidebars/plan.vue'),
      },
    },        
    {
      path: '/system/User',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/user.vue'),
      },
    },
    {
      path: '/system/Group',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/group.vue'),
      },
    },
    {
      path: '/system/GroupMember',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/groupMember.vue'),
      },
    },
    {
      path: '/system/Permission',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/permission.vue'),
      },
    },
    {
      path: '/system/Workflow',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/workflow.vue'),
      },
    },
    {
      path: '/system/WorkflowPermission',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/workflowPermission.vue'),
      },
    },
    {
      path: '/system/WorkflowAction',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/workflowAction.vue'),
      },
    },
    {
      path: '/system/Word',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/word.vue'),
      },
    },
    {
      path: '/system/CustomTemplate',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/customTemplate.vue'),
      },
    },
    {
      path: '/system/ReportTemplate',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/reportTemplate.vue'),
      },
    },
      {
      path: '/system/ReportLayout',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/reportLayout.vue'),
      },

    },
    {
      path: '/system/BatchSchedule',
      components: {
        sidebar: () => import('@/agiles/sidebars/system.vue'),
        default: () => import('@/agiles/vues/batchSchedule.vue'),
      },          
    },
    {
      path: '/setting/Personal',
      components: {
        sidebar: () => import('@/agiles/sidebars/personal.vue'),
        default: () => import('@/agiles/vues/personal.vue'),
      },
    },
    {
      path: '/setting/Favorite',
      components: {
        sidebar: () => import('@/agiles/sidebars/personal.vue'),
        default: () => import('@/agiles/vues/favorite.vue'),
      },
    },
    {
      path: '/setting/SystemLog',
      components: {
        sidebar: () => import('@/agiles/sidebars/personal.vue'),
        default: () => import('@/agiles/vues/systemLog.vue'),
      },
    },
    {
      path: '/setting/Topics',
      components: {
        sidebar: () => import('@/agiles/sidebars/personal.vue'),
        default: () => import('@/agiles/vues/topics.vue'),
      },
      props: { default: (route : Route) =>({isAdmin:true,isEditMode:false}), sidebar: false }          
    },
  ],
});
